export class AuthResult {
  username: string;
  personid: string;
  token: string;
  firstName: string;
  lastName: string;
  email:string;
  error:string;
}
